<template>
  <v-container>
    <v-tabs v-model="currentTab" slider-color="primary">
      <v-tab v-for="tab in tabs" :key="tab.value" :href="`#${tab.value}`">{{ tab.label }}</v-tab>
    </v-tabs>
    <v-divider />
    <div class="mt-3">
      <date-filter
        v-if="!['dashboard', 'customer'].includes(currentTab)"
        ref="datefilter"
        v-model="selectedDate"
        :default-filter="'last_7_days'"
        class="mb-3"
      ></date-filter>
      <component :is="currentTabComponent" :selected-date="selectedDate" />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import DateFilter from '@/components/view/dashboard/DateFilter'
import beaconApi from '@/api/beacon'
import { handleResponse, handleApiError } from '@/api/util'
import Dashboard from './Dashboard'
import Metric from '../Analytics/Metric'
import Customer from './Customer'

export default {
  components: {
    DateFilter
  },
  data() {
    return {
      tabs: [
        {
          label: this.$t('Dashboard'),
          value: 'dashboard',
          component: Dashboard
        },
        {
          label: this.$t('Metrics'),
          value: 'metric',
          component: Metric
        },
        {
          label: this.$t('Customer'),
          value: 'customer',
          component: Customer
        }
      ],
      currentTab: 'dashboard',
      selectedDate: {
        end: dayjs().format('YYYY-MM-DD'),
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    currentTabComponent() {
      return this.tabs.find((tab) => tab.value === this.currentTab).component
    }
  },
  created() {
    this.getBeaconsList()
  },
  methods: {
    async getBeaconsList() {
      try {
        const response = await beaconApi.getBeaconsList({
          pageId: this.selectedBot.pageid,
          config: { limit: 1000, offset: 0 }
        })
        handleResponse(response)
        if (response && response.status === 200 && response.data && response.data.success) {
          const tempResult = response.data.result || []
          this.$store.state.beaconMasterData.beaconBranch = tempResult
        }
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Beacon/AnalyticsV2/index.vue